(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bs-mobile-sticky-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('[data-bs-mobile-sticky-cart]');
    if (!bar) return;

    const stickyButton = bar.querySelector('[data-bs-sticky-submit]');
    const mainButton = document.querySelector('.main-product-form [data-add-to-cart]');
    if (!stickyButton || !mainButton) return;

    const sync = () => {
      stickyButton.disabled = mainButton.disabled;
      const label = mainButton.querySelector('[data-atc-text]');
      if (label && label.textContent.trim()) stickyButton.textContent = label.textContent.trim();
    };

    const observer = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.15 });

    observer.observe(mainButton);
    new MutationObserver(sync).observe(mainButton, {
      attributes: true,
      childList: true,
      subtree: true
    });

    stickyButton.addEventListener('click', () => {
      if (!mainButton.disabled) mainButton.click();
    });

    sync();
  })();
  } catch(e) { console.error(e); }
})();

})();
